import { useNavigate } from 'react-router-dom'

export const TRANSFER_DETAIL_URL = '/assembly/detail/:transferId/:docNum'

export const useGoToTransferDetail = () => {
  const navigate = useNavigate()

  return {
    go: (transferId: string, docNum: string, container?: string) => {
      let url = TRANSFER_DETAIL_URL.replace(':transferId', transferId).replace(
        ':docNum',
        docNum
      )
      if (container) {
        url += `?container=${container}`
      }

      navigate(url)
    }
  }
}
